//////////////////////////////////////20260428//////////////////////////////////////////////////
import React from 'react'
import styled from 'styled-components'
import Toptabs from '../../../service/components/Toptabs'
import Pdfcontain from '../../../service/components/Pdfcontain'
import Out_Main_contract from '../../Outsourcings/Out_Main_contract'
import Out_Contract_signature from '../../Outsourcings/Out_Contract_signature'
import Basic_contract_My from '../../Outsourcings/Basic_contract_My'
import ProjectHeader from './ProjectHeader'
import { STEP } from '../projectStepManager'

function ContractView(props) {
    var userinfo = props.userinfo
    var countNum = props.countNum
    var canViewCurrentNums = props.canViewCurrentNums
    var contract = props.contract
    var exdata = props.exdata
    var contractPage = props.contractPage
    var setStampid = props.setStampid
    var stampid = props.stampid
    var setContract = props.setContract
    var fresh = props.fresh
    var showExampleOverlay = props.showExampleOverlay
    var pg = props.pg
    var displayStep = props.displayStep
    var admin = props.admin
    var imageSrc = props.imageSrc
    var my = props.my

    if (!userinfo) {
        return null
    }

    function moveToSignaturePage() {
        var remain = 5 - contractPage

        if (remain <= 0) {
            return
        }

        function moveNext(times) {
            if (times <= 0) {
                return
            }

            if (typeof countNum === 'function') {
                countNum(1)
            }

            setTimeout(function () {
                moveNext(times - 1)
            }, 30)
        }

        moveNext(remain)
    }

    var viewContract = canViewCurrentNums && contract ? contract : exdata
    var title =
        displayStep === STEP.CONTRACT_WRITE
            ? '계약서 작성'
            : displayStep === STEP.CONTRACT_RECEIVE
            ? '계약서 수신'
            : displayStep === STEP.CONTRACT_SIGN
            ? '계약서 서명'
            : '계약서'

    // var showSpecPreview =
    //     admin &&
    //     (displayStep === STEP.CONTRACT_WRITE ||
    //         displayStep === STEP.CONTRACT_RECEIVE ||
    //         displayStep === STEP.CONTRACT_SIGN)
    // var showSpecPreview =
    //     (admin || my) &&
    //     (displayStep === STEP.CONTRACT_WRITE ||
    //         displayStep === STEP.CONTRACT_RECEIVE ||
    //         displayStep === STEP.CONTRACT_SIGN)
    var showSpecPreview = admin || props.my

    return (
        <ViewRoot>
            {/* <ProjectHeader
                pg={pg}
                viewTitle={
                    displayStep === STEP.CONTRACT_RECEIVE
                        ? '계약서 수신'
                        : displayStep === STEP.CONTRACT_SIGN
                        ? '계약서 서명'
                        : '계약서 작성'
                }
            /> */}
            <ProjectHeader pg={pg} viewTitle={title} />

            {showSpecPreview && imageSrc && imageSrc.base64 ? (
                <SpecSection>
                    <Pdfcontain
                        top={false}
                        list={viewContract && viewContract.specification ? viewContract.specification : ''}
                        single={true}
                        type="specification"
                        types="only"
                        num={2}
                        mini={true}
                        file={imageSrc.base64}
                        data={viewContract}
                    />
                </SpecSection>
            ) : null}

            <ContractSection>
                <TopSection>
                    <TopActions>
                        <Toptabs
                            countNum={countNum}
                            top={true}
                            data={viewContract}
                            userinfo={userinfo}
                            value={'계약서'}
                            num={contractPage}
                        />

                        {!admin ? (
                            <SignMoveButton type="button" onClick={moveToSignaturePage}>
                                전자서명 이동
                            </SignMoveButton>
                        ) : null}
                    </TopActions>
                </TopSection>

                <BodySection>
                    {contractPage === 0 ? (
                        <Out_Main_contract
                            contract={
                                canViewCurrentNums && contract && contract.uid !== 'exampledata' ? contract : exdata
                            }
                        />
                    ) : contractPage >= 1 && contractPage <= 4 ? (
                        <Basic_contract_My num={contractPage} userinfo={userinfo} />
                    ) : contractPage === 5 ? (
                        <SignatureWrap>
                            <Out_Contract_signature
                                notmain={admin}
                                admin={admin}
                                userinfo={userinfo}
                                contract={viewContract}
                                setStampid={setStampid}
                                stampid={stampid}
                                setContract={setContract}
                                fresh={fresh}
                            />
                        </SignatureWrap>
                    ) : null}
                </BodySection>
            </ContractSection>

            {showExampleOverlay ? <div className="text_absolute">계약서 예시입니다</div> : ''}
        </ViewRoot>
    )
}

export default ContractView

const ViewRoot = styled.div`
    width: 100%;
`

const SpecSection = styled.div`
    margin-bottom: 40px;
    padding-bottom: 32px;
    border-bottom: 1px solid #757575;
`

const ContractSection = styled.div`
    width: 100%;
`

const TopSection = styled.div`
    margin-top: 0;
`

const TopActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
`

const BodySection = styled.div`
    margin-top: 20px;
`

const SignatureWrap = styled.div`
    padding: 20px 0;
`

const SignMoveButton = styled.button`
    margin-top: -5px;
    height: 42px;
    padding: 0 16px;
    border: none;
    border-radius: 8px;
    background-color: #1baacc;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    white-space: nowrap;
`
